/* BRILYA — panier personnalisé v2 (tiroir) */
(function(){
  var LOCK='<svg class="pwx-lock" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path fill="currentColor" d="M12 2a5 5 0 0 0-5 5v3H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-1V7a5 5 0 0 0-5-5Zm-3 8V7a3 3 0 1 1 6 0v3H9Z"/></svg>';
  var promoOpen=false;
  function eur(el){
    var t=(el.textContent||'').trim(); if(t.indexOf('€')<0||/^\d[\d\s.,]*\s?€$/.test(t)) return;
    var m=t.match(/\d[\d\s.,]*\d|\d/); if(m) el.textContent=m[0].replace(/\s+/g,'')+' €';
  }
  var busy=false;
  function enhance(){
    var dr=document.querySelector('cart-drawer'); if(!dr||busy) return; busy=true;
    try{
      /* titre + compteur */
      var n=0; dr.querySelectorAll('.cart-item .quantity__input').forEach(function(i){ n+=parseInt(i.value,10)||0; });
      var h=dr.querySelector('.drawer__header .drawer__heading');
      if(h){ var html='Votre panier'+(n?' <span class="pwx-cartcount">'+n+'</span>':''); if(h.innerHTML!==html){ h.innerHTML=html; } h.classList.add('pwx-cart-title'); }
      /* bouton de paiement */
      var b=dr.querySelector('#CartDrawer-Checkout'); if(b&&!b.querySelector('.pwx-lock')) b.innerHTML=LOCK+' Passer au paiement sécurisé';
      /* bloc de confiance sous le bouton */
      var footer=dr.querySelector('.drawer__footer');
      var ctas=dr.querySelector('.drawer__footer .cart__ctas'), tpl=document.getElementById('pwx-trust-tpl');
      if(ctas&&tpl&&!dr.querySelector('.drawer__footer .pwx-trust')) ctas.insertAdjacentHTML('afterend',tpl.innerHTML);
      /* réassurance déplacée sous les articles (le pied reste compact) */
      var zone=dr.querySelector('.cart-drawer-items-and-upsell'), src=dr.querySelector('.drawer__footer .pwx-trust__list');
      if(zone&&src&&!zone.querySelector('.pwx-reassure')&&dr.querySelector('.cart-item')){
        var ul=src.cloneNode(true); ul.className='pwx-reassure'; ul.setAttribute('role','list'); zone.appendChild(ul);
      }
      if(zone&&!dr.querySelector('.cart-item')){ var old=zone.querySelector('.pwx-reassure'); if(old) old.remove(); }
      /* prix : format, et prix unitaire seulement si quantité > 1 */
      dr.querySelectorAll('.totals__total-value,.cart-drawer__final-item-price,.cart-item__details .product-option,.cart-item__old-price,.cart-item__final-price').forEach(eur);
      dr.querySelectorAll('.cart-item').forEach(function(row){
        var q=parseInt((row.querySelector('.quantity__input')||{}).value,10)||1;
        var u=row.querySelector('.cart-item__details > .product-option, .cart-item__details > .cart-item__discounted-prices');
        if(!u) return;
        if(u.classList.contains('product-option')&&(u.textContent||'').indexOf('€')<0) return;
        u.classList.add('pwx-unit');
        if(u.classList.contains('product-option')&&q>1&&!u.querySelector('.pwx-u')){ u.insertAdjacentHTML('beforeend',' <span class="pwx-u">l’unité</span>'); }
        u.classList.toggle('pwx-unit--show',q>1);
      });
      /* code promo replié derrière un lien */
      var disc=dr.querySelector('.drawer__footer .cart-discount');
      if(footer&&disc){
        var tg=footer.querySelector('.pwx-promo-toggle');
        if(!tg){
          tg=document.createElement('button'); tg.type='button'; tg.className='pwx-promo-toggle'; tg.textContent='J’ai un code promo';
          tg.addEventListener('click',function(){ promoOpen=!promoOpen; apply(); if(promoOpen){ var inp=dr.querySelector('.drawer__footer .cart-discount .field__input'); if(inp) inp.focus(); } });
          footer.insertBefore(tg,disc);
        }
        var inp0=disc.querySelector('.field__input'); if(inp0&&inp0.value) promoOpen=true;
        apply();
      }
      function apply(){
        var d=dr.querySelector('.drawer__footer .cart-discount'), t=dr.querySelector('.drawer__footer .pwx-promo-toggle');
        if(d) d.classList.toggle('pwx-collapsed',!promoOpen);
        if(t) t.setAttribute('aria-expanded',promoOpen?'true':'false');
      }
    }catch(e){}
    busy=false;
  }
  function start(){
    enhance();
    var dr=document.querySelector('cart-drawer'); if(!dr||!window.MutationObserver) return;
    var t; new MutationObserver(function(){ if(busy) return; clearTimeout(t); t=setTimeout(enhance,30); }).observe(dr,{childList:true,subtree:true});
  }
  if(document.readyState!=='loading') start(); else document.addEventListener('DOMContentLoaded',start);
})();
